module.exports = __webpack_public_path__ + "img/n5.55651945.jpg";